module.exports = __webpack_public_path__ + "static/media/print_01_C.78a0b42d.png";